<template>
  <div id="highSchoolEntry">
    <!-- High School Entry CARD -->
    <v-card v-if="school.high_school_entry" outlined>
      <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0"> 
        <span class="title font-weight-regular  align-center mt-1">Direct High School Entry</span>
      </v-layout>
      <v-container  pb-1>
        <v-layout column>
          
          
          <v-layout justify-center mt-4 pb-3>
            <span class="font-weight-light title grey--text">Info Coming Soon</span>
          </v-layout>


        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['school'],
  data () {
    return {

    }
  }
}
</script>

<style scoped>
   .card {
    border-radius: 10px;
  }
     #buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
</style>



// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/HighSchoolEntry.vue